// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__2fxdm","background":"NotFound_background__2jAlA","glow":"NotFound_glow__1496E","glowing":"NotFound_glowing__d5h2C"};